import { useOutletContext } from "react-router-dom";
import LibraryPanel from "../../components/LibraryPanel";

export default function PortalLibrary() {
  const { summary } = useOutletContext();
  if (!summary) return <div className="p-8 text-neutral-500">Loading…</div>;
  const client = summary.client;
  return (
    <div className="p-6 md:p-8 space-y-6 max-w-[1600px]">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">Asset Vault</div>
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Content Library</h1>
        <p className="text-neutral-600 text-sm mt-1">All your brand assets in one place — logos, guidelines, photos, videos, templates and campaign creatives.</p>
      </div>
      <LibraryPanel clientId={client.id} clientName={client.client_name}/>
    </div>
  );
}
